import React, { useContext } from 'react';
import { useSearch } from '../../SearchContext';
import Card from '~/components/Card';
import { loadingContext } from '~/context/loading';

export const CardContainer: React.FC = () => {
  const {
    codTela,
    isUpdateCard,
    isCardFixed,
    showTable,
    setIsOpenModal,
    setShowTable,
    setIsCardFixed,
    setDataEdit,
    dataEdit,
    backSearch,
    setBackSearch,
    setUpdateCard,
    isOpenModal,
    searchTextWatch,
    tipoAcesso,
  } = useSearch();

  const { handleLoadingPageSearch } = useContext(loadingContext);

  return (
    <Card
      codTelaProp={codTela}
      handleSearch={async () => {
        setShowTable(true);
      }}
      showTable={showTable}
      onShowTable={setShowTable}
      isOpenModal={isOpenModal}
      setIsOpenModal={setIsOpenModal}
      isUpdateCard={isUpdateCard}
      setUpdateCard={setUpdateCard}
      BackSearchProps={backSearch}
      setBackSearchProps={setBackSearch}
      setDataEdit={setDataEdit}
      dataEdit={dataEdit}
      setIsCardFixed={setIsCardFixed}
      isCardFixed={isCardFixed}
      setLoading={(val: boolean) => handleLoadingPageSearch(val, codTela)}
      textFiltro={searchTextWatch}
      tipoFiltro={tipoAcesso}
    />
  );
};
